export default __webpack_public_path__ + "static/media/wood5.f6821339.jpg";